<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="times"
    item-text="name"
    item-value="code"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    dark>
  </v-select>
</template>

<script>
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    computed: {
      times () {
        const result = []
        for (let hour = 0; hour < 24; hour++) {
          for (let minute = 0; minute < 60; minute += 30) {
            result.push([
              `0${hour}`.slice(-2),
              `0${minute}`.slice(-2)
            ].join(':'))
          }
        }
        result.push('24:00')
        return result
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Time.vue